angular.module('analytics.mixpanel', []);
